import React from 'react';
import DOMPurify from 'dompurify';
import {Theme, mergeStyles, useTheme} from 'components/FluentUICompat';

type HtmlComponentProps = {
	htmlContent: string;
};

export const HtmlComponent: React.FC<HtmlComponentProps> = ({htmlContent}) => {
	const theme = useTheme();
	const className = getHTMLClassName(theme);

	const cleanHtml = DOMPurify.sanitize(htmlContent);

	return (
		<div
			className={className}
			dangerouslySetInnerHTML={{__html: cleanHtml}}
		></div>
	);
};

export const getHTMLClassName = (theme: Theme) => {
	return mergeStyles({
		'& table, th, td': {
			border: `1px solid ${theme.palette.neutralSecondaryAlt}`,
			borderCollapse: 'collapse',
		},
		'& th, td': {
			padding: 5,
			minWidth: 50,
		},
		overflowX: 'auto',
	});
};
